import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router';
import { darken, rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TableRow, TableTd } from '../General/Table';
import { DsiSvgIcon as SvgIcon, Modal } from '../../..';
import { IconType } from '../General/SvgIcon';
import { Button } from '../../Zemplin/General/Button';
import { CountSetter } from '../Product/CountSetter';
import { useState } from 'react';
import {
  getCartItemInfo,
  getProductDetailInfo,
} from '../../../utilities/selectors';
import { formatPrice, formatPriceToString, prop } from '../../../utilities';
import { isNumeric, isPositiveNumeric } from './utilities';
import { getImagePath } from '../../../utilities/product';
import { __ } from 'react-i18n';
import { DsiGiftChooserModalContent } from './GiftChooserModalContent';

export interface Props {
  item?: any;
  theme: any;
  updateCart: any;
  addToCart: any;
  removeFromCart: any;
  isB2B?: boolean;
  availableGifts?: any[];
  originalItem?: any;
  itemIndex?: number;
  isMobile?: boolean;
  showRemove?: boolean;
  chooseModalWithPrices?: boolean;
  chooseModalAddToCart?: boolean;
}

function ProductCartTableSaleRow(props: Props) {
  const {
    item,
    addToCart,
    removeFromCart,
    updateCart,
    isB2B,
    theme,
    availableGifts,
    originalItem,
    itemIndex,
    isMobile,
    showRemove,
    chooseModalAddToCart,
  } = props;

  const {
    name,
    plu: ordernr,
    availid: availId,
    availability,
    image,
    url: productUrl,
    currency: currencyId,
    unit,
  } = getProductDetailInfo(item);

  const [isChangeModalOpen, setIsChangeModalOpen] = useState(false);

  const toggleChangeModal = () => {
    setIsChangeModalOpen(o => !o);
  };

  const closeModal = () => {
    setIsChangeModalOpen(false);
  };

  const handleChooseGift = chosenItem => {
    closeModal();
    if (chooseModalAddToCart) {
      addToCart({
        product: { ...chosenItem, main_good_id: chosenItem.main_good.good_id },
        good: chosenItem.main_good,
      });
    } else {
      const itemCopy = { ...originalItem };
      const chosenGiftsCopy = itemCopy.chosen_gifts
        ? [...itemCopy.chosen_gifts]
        : [];

      if ((itemIndex || itemIndex === 0) && itemIndex !== -1) {
        chosenGiftsCopy[itemIndex] = chosenItem;
      } else {
        chosenGiftsCopy.push(chosenItem);
      }
      updateCart({ ...originalItem, chosen_gifts: chosenGiftsCopy });
    }
  };

  const handleRemoveGift = () => {
    const restrict_gifts_good_ids = originalItem?.restrict_gifts_good_ids
      ?.length
      ? [...originalItem.restrict_gifts_good_ids]
      : [];
    restrict_gifts_good_ids.push(item.main_good.good_id);

    const chosen_gifts = originalItem?.chosen_gifts?.length
      ? originalItem.chosen_gifts.filter(originalItemItemChosenGift => {
          return (
            originalItemItemChosenGift.main_good.good_id !==
            item.main_good.good_id
          );
        })
      : [];

    updateCart({ ...originalItem, chosen_gifts, restrict_gifts_good_ids });
  };

  const renderContent = () => {
    return (
      <>
        <PlusIconWrapper>
          <SvgIcon
            fill={'white'}
            icon={IconType.plus}
            viewBox={'0 0 8 8'}
            width={12}
            height={12}
          />
        </PlusIconWrapper>
        <ImageNameTableTd>
          <StyledLink to={productUrl}>
            <Image
              alt={`Obrázok ku produktu ${name ? name : ''}`}
              src={`${getImagePath(image, { width: 160, height: 160 })}`}
            />
          </StyledLink>
          <StyledLink to={productUrl}>
            <NameInputWrapper>
              <Name>{prop(item, 'name')}</Name>
              <Plu>{`${ordernr}`}</Plu>
              {/* <Availability
                  availId={availId}
                >{`${availability}`}</Availability> */}
            </NameInputWrapper>
          </StyledLink>
        </ImageNameTableTd>
        <ChangeGiftTableTd align={'right'}>
          {prop(availableGifts, 'length') > 1 && (
            <ChangeGiftButton onClick={toggleChangeModal}>
              <ChangeGiftText>{__('Zmeniť darček')}</ChangeGiftText>
            </ChangeGiftButton>
          )}
        </ChangeGiftTableTd>
        <StyledTableTd align={'center'}>
          <FlexRowCenterVertical>
            <CountText marginLeft={isMobile?18:38}>{`${prop(item, 'count') ||
              1} ${unit}`}</CountText>
          </FlexRowCenterVertical>
        </StyledTableTd>

        {showRemove ? (
          <>
            <StyledTableTd align={'right'}>
              <RemoveGiftIconWrapper>
                <SvgIcon
                  icon={IconType.gift}
                  width={24}
                  height={24}
                  fill={theme.colors.primary}
                />
                <CellText fontWeight={500}>{__('Darček')}</CellText>
              </RemoveGiftIconWrapper>
            </StyledTableTd>
            <StyledTableTd align={'center'}>
              <StyledButton onClick={handleRemoveGift}>
                <SvgIcon
                  cursor={'pointer'}
                  icon={IconType.trash}
                  width={24}
                  height={24}
                  fill={'#000000'}
                />
              </StyledButton>
            </StyledTableTd>
          </>
        ) : (
          <>
            <StyledTableTd align={'right'}>
              <CellText fontWeight={500}>{__('Darček')}</CellText>
            </StyledTableTd>
            <StyledIconTableTd align={'center'}>
              <SvgIcon
                icon={IconType.gift}
                width={24}
                height={24}
                fill={theme.colors.primary}
              />
            </StyledIconTableTd>
          </>
        )}
      </>
    );
  };

  const renderChooseContent = () => {
    return (
      <>
        <PlusIconWrapper>
          <SvgIcon
            fill={'white'}
            icon={IconType.plus}
            viewBox={'0 0 8 8'}
            width={12}
            height={12}
          />
        </PlusIconWrapper>
        <ImageNameTableTd />
        <GiftStyledTableTd align={'right'} isMobile={isMobile}>
          <ChangeGiftButton onClick={toggleChangeModal}>
            <SvgIcon
              icon={IconType.gift}
              width={24}
              height={24}
              fill={theme.colors.primary}
              marginRight={16}
            />
            <ChangeGiftText fontSize={'large'}>
              {__('Vyberte si darček')}
            </ChangeGiftText>
          </ChangeGiftButton>
        </GiftStyledTableTd>
        <StyledTableTd align={'center'} />
        <StyledTableTd align={'right'} />
        <StyledTableTd align={'center'} />
      </>
    );
  };

  return (
    <>
      {isMobile ? (
        <StyledTableDiv>
          <tbody style={{ display: 'block' }}>
            <tr style={{ display: 'block' }}>
              {item ? renderContent() : renderChooseContent()}
            </tr>
          </tbody>
        </StyledTableDiv>
      ) : (
        <StyledTableRow>
          {item ? renderContent() : renderChooseContent()}
        </StyledTableRow>
      )}
      {isChangeModalOpen && (
        <Modal
          style={{ height: '90%', maxWidth: '800px', width: '90%' }}
          size={'medium'}
          showX={true}
          closeModal={closeModal}
        >
          <DsiGiftChooserModalContent
            items={availableGifts}
            handleChooseGift={handleChooseGift}
          />
        </Modal>
      )}
    </>
  );
}

const StyledTableTd = styled(TableTd)<{ align?: string }>`
  text-align: ${({ align }) => (align ? align : 'left')};
  padding: ${rem(18)} ${rem(16)};
  width: 100%;
`;

const StyledIconTableTd = styled(StyledTableTd)`
  padding-left: 0;
`;

const ChangeGiftTableTd = styled(StyledTableTd)`
  ${({ theme }) => theme.mediab.m810`
     width: unset;
     padding-right: 0;
     padding-left: ${rem(12)};
  `}
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border: 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  position: relative;
  top: ${rem(-4)};
`;

const StyledTableDiv = styled.table`
  display: block;
  padding: ${rem(18)} 0;
  border: 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  position: relative;
  top: ${rem(-4)};
  background: white;
`;

const StyledChooseTableRow = styled(StyledTableRow)``;

const CellText = styled(TextP)<{ fontWeight: number; marginLeft?: number }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '400')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(14)};
  `}
`;

const ChangeGiftButton = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: 0;
  display: flex;
  flex-flow: row;
  align-items: center;

  &:hover {
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }

  ${({ theme }) => theme.mediab.m810`
      display: flex;
      justify-content: center;
      flex-flow: column;
      padding: 0;
  `}
`;

const ChangeGiftText = styled(CellText)<{ fontSize?: string }>`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: ${({ fontSize }) =>
    fontSize === 'large' ? 'none' : 'underline'};
  background: none;
  font-size: ${({ fontSize }) => (fontSize === 'large' ? rem(20) : rem(14))};
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.tertiary};

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(14)};
  `}
`;

const CountText = styled(TextP)<{ marginLeft?: number }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-left: ${({ marginLeft }) => (marginLeft ? rem(marginLeft) : 0)};
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(14)};
  `}
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
  max-width: ${rem(300)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Image = styled.img`
  width: ${rem(56)};
  max-width: ${rem(56)};
  height: ${rem(56)};
  /* max-width: initial; */
  margin-right: ${rem(16)};
`;

const NameInputWrapper = styled(FlexCol)`
  max-width: ${rem(400)};

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(200)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(180)};
  `}

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(130)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(200)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  margin-bottom: ${rem(4)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: ${rem(400)}; */
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  /* ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `} */
`;

const Plu = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.colors.placeholder};
  text-align: left;
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 300;
`;

const StyledButton = styled(Button)`
  width: ${rem(56)};
  height: ${rem(56)};
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid rgba(30, 57, 141, 1);
  border-radius: 4px;
  opacity: 0.08;
  padding: 0;
`;

const Availability = styled(TextP)<{ availId: number }>`
  font-size: ${rem(16)};
  color: ${({ theme, availId }) =>
    availId === 1 ? theme.colors.successColor : theme.colors.dangerColor};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const PlusIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 50%;
  width: ${rem(32)};
  height: ${rem(32)};
  background-color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  margin-top: -${rem(20)};
  left: ${rem(24)};
  z-index: 6;

  ${({ theme }) => theme.mediab.m810`
     margin-top: -${rem(36)};
  `}
`;

const RemoveGiftIconWrapper = styled.div`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  float: right;
`;

const GiftStyledTableTd = styled(StyledTableTd)<{ isMobile: boolean }>`
  ${({ isMobile }) => (isMobile ? 'display:flex;justify-content: center;' : '')}
`;

const WithThemeRow: any = withTheme(ProductCartTableSaleRow);
export { WithThemeRow as DsiProductCartTableSaleRow };
